module.exports = __webpack_public_path__ + "static/media/idle.992ba7dc.png";